import {
    EXPAND_PLAN,
    COLLAPSE_PLAN,
} from 'shared_redux/actions';

export const expand = (planId) => ({ type: EXPAND_PLAN, planId });

export const collapse = (planId) => ({ type: COLLAPSE_PLAN, planId });
